export const convertTimezone = (date, tzString) => {
  if (tzString === "Other") {
    return null;
  }

  return new Date(
    (typeof date === "string" ? new Date(`${date}Z`) : date).toLocaleString("en-US", { timeZone: tzString })
  );
};
